import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-default",
  "use": "icon-default-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\" id=\"icon-default\"><title></title><rect x=\"-0.25\" y=\"-0.25\" width=\"100.5\" height=\"100.5\" fill=\"#efefef\" /><circle cx=\"50\" cy=\"35.08\" r=\"14.58\" fill=\"#c9caca\" /><path d=\"M22.64,79.5a27.36,27.36,0,0,1,54.72,0\" fill=\"#c9caca\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol